/** OGTS LogiCore™ — Analytics-matched White & Silver palette */
export const P = {
  silver: '#F1F5F9',
  white: '#FFFFFF',
  grid: '#E2E8F0',
  blue: '#3B82F6',
  blueTint: '#EFF6FF',
  btnBlue: '#BFDBFE',
  btnBlueBorder: '#93C5FD',
  text: '#1E293B',
  muted: '#64748B',
  subtle: '#94A3B8',
  orange: '#F97316',
  orangeTint: '#FFF7ED',
};

export const lightRoot = {
  backgroundColor: P.silver,
  color: P.text,
  colorScheme: 'light',
};

export const lightCard = {
  backgroundColor: P.white,
  borderColor: P.grid,
};

export const btnLightBlue =
  'border border-[#93C5FD] bg-[#BFDBFE] font-bold text-black transition hover:bg-[#93C5FD]';
